import CampaignParticipants from './CampaignParticipants';

export default CampaignParticipants;
